export const capitalize = (text?: string) => {
    if(text){
        if(text.length === 1){
            return text;
        }
        return text.slice(0,1).toUpperCase() + text.slice(1, text.length);
    }
    return text;
}